import { isDrayNow } from '../../../lib/config/multitenancy.js'

/**
 * The Kinde org code for the active theme — the org hint every login()
 * call must carry so Kinde brands the flow and scopes the token.
 */
export function getKindeOrgCode() {
  return isDrayNow
    ? (process.env.REACT_APP_KINDE_ORG_DRAYNOW ?? '')
    : (process.env.REACT_APP_KINDE_ORG_MODALVIEW ?? '')
}

/**
 * The Kinde API audience for the active theme — passed to KindeProvider for
 * the initial auth request AND on every direct token refresh, so refreshed
 * access tokens keep the API `aud` claim (without it the backend rejects
 * them — the March 2026 audience-on-refresh bug, c0f144de).
 */
export function getKindeAudience() {
  return isDrayNow
    ? process.env.REACT_APP_KINDE_AUDIENCE_DRAYNOW
    : process.env.REACT_APP_KINDE_AUDIENCE_MODALVIEW
}
